if($(window).width() >= 768){
  var h3height = 0;
  $('.content_column').each(function() {
    if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.content_column').height(h3height);
}
else{
  $('.multi_column_slider').slick({
    slidesToShow: 1,
    dots: true,
    arrows: false,
    infinite: false
  });
}
